import { MediaType } from "@/modules/common/media/mediaTypes"
import type {
  MediaContentDto,
  MediasContentDto,
  SessionMediaDto,
  SessionMediasDto,
} from "@/modules/sessions/sessionDetails/blocks/mediaBlock/mediaBlockDto"
import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import type {
  MediaBlockFormikType,
  MediaBlockItemFormikType,
} from "@/modules/sessions/sessionForm/blocks/mediaBlock/mediaBlockFormikTypes"

export class SessionBlockMediaEntity {
  medias: SessionMediaItemEntity[]
  orderIndex: number
  blockType: typeof SessionBlockType.MEDIAS

  private constructor(sessionBlockMedia: SessionBlockMediaEntity) {
    this.medias = sessionBlockMedia.medias
    this.orderIndex = sessionBlockMedia.orderIndex
    this.blockType = sessionBlockMedia.blockType
  }

  static fromDto(dto: SessionMediasDto): SessionBlockMediaEntity {
    return new SessionBlockMediaEntity({
      medias: dto.medias.map((media) => SessionMediaItemEntity.fromDto(media)),
      orderIndex: dto.orderIndex,
      blockType: dto.blockType,
    })
  }

  static fromEntityToFormik(entity: SessionBlockMediaEntity): MediaBlockFormikType {
    return {
      medias: entity.medias.map((media) => SessionMediaItemEntity.fromEntityToFormik(media)),
    }
  }

  static fromEntityToInputDto(entity: SessionBlockMediaEntity): MediasContentDto {
    return {
      medias: entity.medias.map((media) => SessionMediaItemEntity.fromEntityToInputDto(media)),
    }
  }

  static fromFormikToInputDto(formik: MediaBlockFormikType, orderIndex: number): MediasContentDto {
    return {
      medias: formik.medias.map((media) => SessionMediaItemEntity.fromFormikToInputDto(media, orderIndex)),
    }
  }
}

export class SessionMediaItemEntity {
  id: string
  url: string
  filename: string | null
  type: MediaType

  private constructor(sessionMediaItem: SessionMediaItemEntity) {
    this.id = sessionMediaItem.id
    this.url = sessionMediaItem.url
    this.filename = sessionMediaItem.filename
    this.type = sessionMediaItem.type
  }

  static fromDto(dto: SessionMediaDto): SessionMediaItemEntity {
    return new SessionMediaItemEntity({
      id: dto.id,
      url: dto.url,
      filename: dto.filename,
      type: dto.type,
    })
  }

  static fromEntityToFormik(entity: SessionMediaItemEntity): MediaBlockItemFormikType {
    return {
      id: entity.id,
      url: entity.url,
      filename: entity.filename,
      type: entity.type,
      file: null,
      awsS3Key: null,
      isUploading: false,
    }
  }

  static fromEntityToInputDto(entity: SessionMediaItemEntity): MediaContentDto {
    return {
      id: entity.id,
      url: entity.url,
      awsS3Key: null,
      filename: entity.filename,
      type: entity.type,
      orderIndex: 0,
    }
  }

  static fromFormikToInputDto(formik: MediaBlockItemFormikType, orderIndex: number): MediaContentDto {
    return {
      id: formik.id,
      url: formik.url,
      awsS3Key: formik.awsS3Key,
      filename: formik.filename,
      type: formik.type,
      orderIndex: orderIndex,
    }
  }
}
